/**
 * Get the school object with the given ID
 * @returns {object} school
 */
export function getSchoolByID(state, schoolID) {
  return state.getIn([ "teachers", "schools", schoolID ] );
}

/**
 * Get the server id of the school with the given ID
 * @returns {string}
 */
export function getServerID(state, schoolID) {
  return state.getIn([ "teachers", "schools", schoolID, "serverId" ] );
}

/**
 * Get the name of the school with the given ID
 * @returns {string}
 */
export function getSchoolName(state, schoolID) {
  return state.getIn(["teachers", "schools", schoolID, "name"]);
}

/**
 * Get the ID of the last visited school
 * @returns {number}
 */
export function getLastSchoolID(state) {
  return state.getIn(["teachers", "lastSchoolID"]);
}

/**
 * Get the number of available schools
 * @returns {number}
 */
export function getSchoolCount(state) {
  return state.getIn([ 'teachers', 'schools' ]).size;
}

/**
 * Check if there is a school with the given ID
 * @returns {boolean}
 */
export function doesSchoolExist(state, schoolID) {
  return getSchoolIDList(state).includes(schoolID);
}

/**
 * Get a list of the available schools ordered alphabetically
 * @returns {Immutable.Seq}
 */
export function getSchoolIDList(state) {
  return getSchoolList(state).map( school => school.get("id") );
}

/**
 * Get a list of the available schools ordered alphabetically
 * @returns {Immutable.Seq}
 */
export function getSchoolList(state) {
  return state.getIn(['teachers', 'schools'] )
    .valueSeq()
    .toList()
    .sortBy((school) => school.get("name"))
}

/**
 * Get the timezoneOffset of the school with the given ID
 * @returns {string}
 */
export function getSchoolTimezoneOffset(state, schoolID) {
  return state.getIn([ "teachers", "schools", schoolID, "timezoneOffset" ]);
}

/**
 * Get the repliesEnabled property for the school with the given ID
 * @returns {boolean}
 */
export function isRepliesEnabledForSchool(state, schoolID) {
  return state.getIn(["teachers", "schools", schoolID, "repliesEnabled"]);
}

/**
 * @returns {boolean}
 */
export function isSchoolsLoading(state) {
  return state.getIn(["teachers", "isSchoolsLoading"]);
}

/**
 * Return true if schools have loaded and we have an activeSchoolID
 * @returns {boolean}
 */
export function isSchoolsReady(state) {
  return !isSchoolsLoading(state);
}

/**
 * Return the schoolid for the given remoteschoolID
 * @returns {string}
 */
export function getSchoolIDFromRemoteSchoolID(state, remoteSchoolID) {
  const schoolList = getSchoolList(state);
  return schoolList.filter(school => school.get("remoteSchoolID") === remoteSchoolID).toObject()[0].schoolID;
}



// WEBPACK FOOTER //
// ./src/state/teachers/selectors/schools.js